import React from "react";
import styled from "styled-components";

export default function ProjectBox({ img, title, text, alt, action, children, delay }) {
  return (
    <Wrapper className="radius8" style={{ animationDelay: `${delay || 0}s` }}>
      <ImgBtn
        className="animate pointer"
        onClick={action ? () => action() : null}
        type="button"
      >
        <ImgWrapper>
          <img src={img} alt={alt || "product"} />
        </ImgWrapper>
      </ImgBtn>
      <Content>
        <h3 className="font20 extraBold">{title}</h3>
        <p className="font10">{text}</p>
      </Content>
      {children && <Footer>{children}</Footer>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 4px 20px rgba(11, 9, 59, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  opacity: 0;
  animation: cardIn 0.6s ease forwards;
  will-change: transform;

  :hover {
    transform: translateY(-10px);
    box-shadow: 0 14px 30px rgba(11, 9, 59, 0.15);
  }

  @keyframes cardIn {
    from {
      opacity: 0;
      transform: translateY(24px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
  }
`;
const ImgBtn = styled.button`
  background-color: transparent;
  border: 0px;
  outline: none;
  padding: 0px;
  margin: 0px;
  width: 100%;
  overflow: hidden;
  :hover img {
    transform: scale(1.06);
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #f9f7fa;
  @media (max-width: 500px) {
    height: 180px;
  }
  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    transition: transform 0.35s ease;
  }
`;
const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0 20px;
  h3 {
    padding-bottom: 10px;
  }
  p {
    flex: 1;
  }
`;
const Footer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  > * {
    flex: 1;
    min-width: 0;
    display: flex;
  }
  button {
    white-space: nowrap;
    padding: 15px 10px;
  }
  @media (max-width: 400px) {
    flex-direction: column;
  }
`;
